import { type FC } from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { MonitoringPeriod } from "../model/period";

// Ключ i18n только статический литерал (CRITICAL-RULES, i18n partner):
// выбор по значению периода через явную мапу.
const PERIOD_LABEL_KEYS: Record<MonitoringPeriod, string> = {
  "1h": "streams.monitoring.period.1h",
  "3h": "streams.monitoring.period.3h",
  "6h": "streams.monitoring.period.6h",
  "24h": "streams.monitoring.period.24h",
  broadcast: "streams.monitoring.period.broadcast",
};

interface MonitoringPeriodSelectProps {
  value: MonitoringPeriod;
  periods: MonitoringPeriod[];
  onChange: (period: MonitoringPeriod) => void;
}

export const MonitoringPeriodSelect: FC<MonitoringPeriodSelectProps> = ({
  value,
  periods,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={value}
      onChange={(_event, next: MonitoringPeriod | null) => {
        // Повторный клик по активной кнопке даёт null: период не снимается.
        if (next) onChange(next);
      }}
    >
      {periods.map((period) => (
        <ToggleButton key={period} value={period}>
          {t(PERIOD_LABEL_KEYS[period])}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
